import {Subject} from 'rxjs';

export const FindExpertSubject = new Subject();

export const FindExpertSubscribes = {
  BCG: 'bcgexpert',
  EXTERNAL: 'externalexpert'
}